export const getIsLightTheme = state => state.theme.theme;
